import {mapActions, mapGetters} from "vuex";

export const methods = {
    ...mapActions('login', [
        'previewInvitation',
        'acceptInvitation',
        'redirectAfterAccept',
    ]),
    ...mapActions('events', [
        'rememberUrl'
    ]),
    async checkQueryParams() {
        this.loading = true
        await this.checkRegionAndPlan()
        await this.checkInvitation()
        this.loading = false
    },
    async checkRegionAndPlan() {
        const { region, plan, category, saas } = this.$route.query

        // Se ci sono parametri SAAS (region, plan, category) o flag esplicito saas=true
        // salva in sessionStorage per attivare il flusso SAAS dopo login
        if (region || plan || category || saas === 'true') {
            sessionStorage.setItem('pendingSaasActivation', 'true')

            // Salva anche i parametri per la creazione evento
            if (region || plan || category) {
                await this.rememberUrl({ region, plan, category })
            }
        }
    },
    async checkInvitation() {
        if (this.$route.query.code) {
            await this.previewInvitation({
                code: this.$route.query.code,
                email: this.$route.query.email || ''
            })
        }
    },
    async afterLogin() {
        // redirectAfterAccept gestisce tutto internamente:
        // - Verifica se c'è un invitation
        // - Controlla i permessi 
        // - Fa il redirect appropriato o va a eventList come fallback
        // - Pulisce l'invitation dopo il redirect
        await this.redirectAfterAccept(this.$router)
    },
    async manageLoginError(e, email) {
        if (e.data.code === 'user_require_validation')
            return await this.$router.push({name: 'login.validate', params: {email: email}})
        if (e.data.code === 'user_not_allowed_in_dashboard')
            return await this.displayError('Access in dashboard is not allowed')
        if (e.data.code === 'registration_not_allowed')
            return await this.displayError('Registration is not allowed')
        if (e.data.error === 'access_denied')
            return await this.displayError('User not found')
        if (e.data.non_field_errors)
            return await this.displayError(JSON.stringify(e.data.non_field_errors[0]))
        if (e.message.email)
            return await this.displayError(JSON.stringify(e.message.email[0]))
        else if (e.message.password)
            return await this.displayError(JSON.stringify(e.message.password))
        return false
    },
    displayError(message) {
        this.error = message
        return true
    },
}

export const computed = {
    ...mapGetters('login', [
        'isAuthenticated',
        'invitation',
    ]),
}

